<template>
    <div>
        <smart-nav name="MEMBERS" @menu-updated="menuUpdated"/>
        <div><v-btn text @click="leaveCloak" v-show="$page.is_impersonating">Leave Cloak</v-btn></div>
        <v-btn text @click="logout">Logout</v-btn>
    </div>
</template>

<script>
import SmartNav from "@/SmartNav/SmartNav.vue";
export default {
    name: "SmartNavSidebar",
    components: {SmartNav},
    methods:{
        logout() {
            axios.post(route('logout').url()).then(response => {
                window.location = '/';
            })
        },
        leaveCloak() {
            this.$inertia.visit(route('user.leave-cloak'), {
                onFinish: visit => {
                    location.reload()   // This will make sure the top-level nav gets reloaded as well.
                }
            })
        },
        menuUpdated(new_menu) {
            this.$emit('menu-updated', new_menu)
        }
    }
}
</script>

<style scoped>

</style>
